<template>
 <div>
    <!-- 司机的新建修改 -->
      <!-- <el-dialog :title="isAdd==true?'新建司机信息':'修改司机信息'" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialog" width="1200px" center> -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialog" width="1200px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="180px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
              <!-- <el-form-item label="身份证号:" prop="identityNo">
                <el-input  placeholder="" :class="{ 'disabled': !isAdd }"  :readonly="!isAdd" @blur="CPHfn()"   maxlength="18" v-model.trim="addFrom.identityNo"></el-input>
              </el-form-item>
               <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder="" :class="{ 'disabled': !isAdd }"  :readonly="!isAdd" maxlength="11" v-model.trim="addFrom.name"></el-input>
              </el-form-item> -->
              <el-form-item label="身份证号:" prop="identityNo">
                <el-input  placeholder=""  @blur="CPHfn()" :readonly="read" :class="read?'disabled':''"  maxlength="18" v-model.trim="addFrom.identityNo"></el-input>
              </el-form-item>
               <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder=""  maxlength="11"  :readonly="read" :class="read?'disabled':''" v-model.trim="addFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="addFrom.mobile" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
               <el-form-item label="司机所属:" prop="driverClassify">
                <el-select placeholder="请选择" v-model="addFrom.driverClassify" @change="driverClassifyChange" :disabled="read" :class="read?'disabled':''">
                  <el-option
                    v-for="item in vehicleSS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="所属单位/个人:"  prop="driverTenant" v-if="addFrom.driverClassify==1" key="1">
                <el-select placeholder="请选择"  filterable allow-create  remote reserve-keyword  :remote-method="remoteMethod"
                default-first-option v-model="addFrom.driverTenant" value-key="tenantCode" :disabled="read" :class="read?'disabled':''">
                  <el-option
                    v-for="(item,index) in ssdw"
                    :key="index"
                    :label="item.tenantName"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="所属单位/个人:" prop="driverTenantName" v-if="addFrom.driverClassify==2" key="2">
                <el-input  placeholder="" v-model="addFrom.driverTenantName"  maxlength="11" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
              <el-form-item label="驾驶证号:" prop="licenseNum">
                <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.licenseNum" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
                <el-form-item label="驾驶证档案号:" prop="certificateNum">
                <el-input  placeholder="" maxlength="50" v-model.trim="addFrom.certificateNum" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
               <el-form-item label="身份证是否长期:" prop="sfzcq" class="ziti" >
                  <template >
                    <div style="width:150px">
                       <el-radio-group v-model="addFrom.sfzcq"  :disabled="read" :class="read?'disabled':''">
                        <el-radio :label="1" >是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item label="身份证有效期:" prop="identityExpiringDate" v-if="addFrom.sfzcq==2">
                <el-date-picker
                  v-model="addFrom.identityExpiringDate"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期时间"
                  :readonly="read" :class="read?'disabled':''"
                ></el-date-picker>
                </el-form-item>
              <el-form-item label="道路运输从业资格证:"  prop="qualificationNum">
                  <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.qualificationNum" :readonly="read" :class="read?'disabled':''"></el-input>
                </el-form-item>
              <el-form-item label="准驾车型:"  filterable prop="quasiDrivingModel" >
                <el-select placeholder="请选择"   v-model="addFrom.quasiDrivingModel" :disabled="read" :class="read?'disabled':''">
                  <el-option
                    v-for="(item,index) in zjcx"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="驾驶证发证机关:"  prop="issueAuthority">
                <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.issueAuthority" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
              <el-form-item label="驾照起始日期:" prop="validPeriodFrom">
                <el-date-picker
                  v-model="addFrom.validPeriodFrom"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                  :readonly="read" :class="read?'disabled':''"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="驾照是否长期:" prop="jzcq" class="ziti"  >
                  <template >
                    <div style="width:150px">
                       <el-radio-group v-model="addFrom.jzcq"  :disabled="read" :class="read?'disabled':''">
                        <el-radio :label=1 >是</el-radio>
                        <el-radio :label=2>否</el-radio>
                      </el-radio-group>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item label="驾照结束日期:" prop="validPeriodTo" v-if="addFrom.jzcq==2">
                <el-date-picker
                  v-model="addFrom.validPeriodTo"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期时间"
                  :readonly="read" :class="read?'disabled':''"
                ></el-date-picker>
                </el-form-item>

               <!-- <el-form-item label="行政区域:" class="diqu is-required" prop="xname" >
                  <shengShiXian :rowData="this.addFrom" @handleChange="handleChange" v-if="flag" :readonly="read" :class="read?'disabled':''"></shengShiXian>
                </el-form-item> -->
                <el-form-item label="行政区域:" class="diqu is-required" prop="xname" v-if="!read">
                  <shengShiXian :rowData="this.addFrom" @handleChange="handleChange" :disabled="read" :class="read?'disabled':''"></shengShiXian>
                </el-form-item>
                <div class="is-need" prop="xname" v-if="read" style="margin-left:93px">
                  行政区域：{{this.addFrom.provinceName}}/{{this.addFrom.cityName}}/{{this.addFrom.areaName}}
                </div>
               <div class="box" v-if="newImgFlag&&!read">
                <div class="imgBox">
                    <uploadImg :img='img' key="0" @remove ='handleRemove'  @change ='imgPreview'></uploadImg>
                    <h6 class="is-need">身份证正面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img1'  key="1"  @remove ='handleRemove1'  @change ='imgPreview1'></uploadImg>
                    <h6  class="is-need">身份证背面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img2'  key="2"  @remove ='handleRemove2'  @change ='imgPreview2'></uploadImg>
                    <h6  class="is-need">驾驶证正面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img3' key="3"   @remove ='handleRemove3'  @change ='imgPreview3'></uploadImg>
                    <h6  class="is-need">驾驶证背面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img4' key="4"   @remove ='handleRemove4'  @change ='imgPreview4'></uploadImg>
                    <h6  class="is-need">道路运输从业资格证</h6>
                </div>
              </div>
                 <div class="box" v-if="read">
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.identityPhoto1Url"
                      :preview-src-list="[addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl]">
                    </el-image>
                    <h6 class="is-need">身份证正面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.identityPhoto2Url"
                      :preview-src-list="[addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url]">
                    </el-image>
                    <h6  class="is-need">身份证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.appendix1Url"
                      :preview-src-list="[addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证正面</h6>
                </div>
                <div class="imgBox">
                     <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.appendix2Url"
                      :preview-src-list="[addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.qualificationPhotoUrl"
                      :preview-src-list="[addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url]">
                    </el-image>
                    <h6  class="is-need">道路运输从业资格证</h6>
                </div>
              </div>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { cDadd, cDupdate, detailDriver, getCDriverInfo } from '@/api/vgs-driver2.0'
import { selectTenantListByName } from '@/api/soc-customer'
import { compressImage } from '@/utils/compressImage'
import uploadImg from '@/components/uploadImg.vue'
import shengShiXian from '@/components/common/shengShiXian.vue'
export default {
  name: 'addDriver',
  components: {
    uploadImg, shengShiXian
  },
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    // isAdd: Boolean
    isAdd: {
      type: Boolean,
      default: true

    }

  },
  data () {
    return {
      read: false,
      dialogVisible: false,
      newImgFlag: false,
      flag: true,
      tableList: [],
      loading: false,
      addFrom: { jzcq: 2, sfzcq: 2 },
      ktzhFrom: {},
      title: '新建司机信息',
      img: [],
      img1: [],
      img2: [],
      img3: [],
      img4: [],
      imgList: [],
      rules: {
        sfzcq: [
          { required: true, message: '请选择身份证是否长期', trigger: 'blur' }
        ],
        jzcq: [
          { required: true, message: '请选择驾照是否长期', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        xname: [
          { required: true, message: '请选择省市县', trigger: 'blur' }
        ],
        driverClassify: [
          { required: true, message: '请选择司机所属', trigger: ['blur', 'change'] }
        ],
        identityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        account: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        licenseNum: [
          { required: true, message: '请输入驾驶证号', trigger: 'blur' }
        ],
        certificateNum: [
          { required: true, message: '请输入驾驶证号档案号', trigger: 'blur' }
        ],
        qualificationNum: [
          { required: true, message: '请输入从业资格证号', trigger: 'blur' }
        ],
        driverTenantName: [
          { required: true, message: '请输入所属单位/个人', trigger: 'blur' }
        ],
        driverTenant: [
          { required: true, message: '请输入所属单位/个人', trigger: 'blur' }
        ],
        quasiDrivingModel: [
          { required: true, message: '请选择准驾车型', trigger: 'blur' }
        ],
        issueAuthority: [
          { required: true, message: '请输入驾驶证发证机关', trigger: 'blur' }
        ],
        identityExpiringDate: [
          { required: true, message: '请选择身份证有效期', trigger: 'blur' }
        ],
        validPeriodFrom: [
          { required: true, message: '请选择驾照起始日期', trigger: 'blur' }
        ],
        validPeriodTo: [
          { required: true, message: '请选择驾照结束日期/个人', trigger: 'blur' }
        ]
      },
      FKfrom: {
        SKlist: []
      },
      ssdw: [], // 所属单位列表
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      zjcx: ['A1', 'A2', 'A3', 'B1', 'B2', 'C1', 'C2', 'C3', 'C4', 'D', 'E']
    }
  },

  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.isAdd) {
      this.addDeiver()
    } else {
      this.modifyDeiver(this.rowData)
    }
    // this.dialogVisible = true
    // this.newImgFlag = true
  },
  methods: {
    // 地区选中
    handleChange (value) {
      if (value) {
        this.addFrom.provinceCode = value[0].areaCode
        this.addFrom.cityCode = value[1].areaCode
        this.addFrom.areaCode = value[2].areaCode
        this.addFrom.provinceName = value[0].name
        this.addFrom.cityName = value[1].name
        this.addFrom.areaName = value[2].name
        this.$set(this.addFrom, 'xname', value[0].name)
      }
    },
    // 所属单位
    remoteMethod (query) {
      console.log(222)
      if (query !== '') {
        selectTenantListByName({ tenantNameLike: query }).then(res => {
          this.ssdw = res
        })
      }
    },
    // 所属切换
    driverClassifyChange () {
      if (this.addFrom.driverClassify == 2) {
        this.$set(this.addFrom, 'driverTenantName', this.addFrom.name)
        this.$set(this.addFrom, 'driverTenantCode', '')
      }
    },
    // 添加保存
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addFrom.driverClassify == 1) {
            if (typeof (this.addFrom.driverTenant) == 'string') {
              this.addFrom.driverTenantName = this.addFrom.driverTenant
              this.addFrom.driverTenantCode = ''
            } else {
              this.addFrom.driverTenantName = this.addFrom.driverTenant.tenantName
              this.addFrom.driverTenantCode = this.addFrom.driverTenant.tenantCode
            }
          }
          if (this.addFrom.sfzcq == 1) {
            this.addFrom.identityExpiringDate = '长期'
          }
          if (this.addFrom.jzcq == 1) {
            this.addFrom.validPeriodTo = '长期'
          }
          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(this.addFrom))
          if (this.imgList.length == 5) {
            let arr = []
            for (let i = 0; i < this.imgList.length; i++) {
              if (this.imgList[i]) {
                if (this.imgList[i] != 1) {
                  arr.push({ img: this.imgList[i], index: i })
                }
              } else {
                this.$alert('请上传证件信息', '系统提示')
                return
              }
            }
            if (arr.length > 0) {
              for (let i = 0; i < arr.length; i++) {
                let a = i
                compressImage(arr[i].img.url, arr[i].img.raw, {
                  width: 1000
                }).then(result => {
                  imgfile.append('file' + arr[a].index, result)// result即为压缩后的结果
                  if (a == arr.length - 1) {
                    if (this.isAdd) {
                      this.addJK(imgfile)
                    } else {
                      this.xiugaiJK(imgfile)
                    }
                  }
                })
              }
            } else {
              if (this.isAdd) {
                this.addJK(imgfile)
              } else {
                this.xiugaiJK(imgfile)
              }
            }
          } else {
            this.$alert('请上传证件信息', '系统提示')
          }
        } else {
          return false
        }
      })
    },
    // 图片上传
    handleRemove (data) {
      this.imgList[0] = null
    },
    imgPreview (data) {
      this.imgList[0] = data[0]
    },
    handleRemove1 (data) {
      this.imgList[1] = null
    },
    imgPreview1 (data) {
      this.imgList[1] = data[0]
    },
    handleRemove2 (data) {
      this.imgList[2] = null
    },
    imgPreview2 (data) {
      this.imgList[2] = data[0]
    },
    handleRemove3 (data) {
      this.imgList[3] = null
    },
    imgPreview3 (data) {
      this.imgList[3] = data[0]
    },
    handleRemove4 (data) {
      this.imgList[4] = null
    },
    imgPreview4 (data) {
      this.imgList[4] = data[0]
    },
    // 司机添加
    addDeiver () {
      // console.log(this.isAdd)
      // console.log('biaoshi')
      this.title = '新建司机信息'
      this.dialogVisible = true
      // this.isAdd = true
      this.newImgFlag = true
      this.addFrom = { jzcq: 2, sfzcq: 2 }
      this.flag = true
      this.read = false
    },
    // 获取司机信息
    CPHfn () {
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        this.newImgFlag = false
        getCDriverInfo({ identityNo: this.addFrom.identityNo }).then(res => {
          loading.close()
          if (res.id) {
            this.addFrom = res
            this.read = true
            if (this.addFrom.identityExpiringDate == '长期') {
              this.$set(this.addFrom, 'sfzcq', 1)
              this.$set(this.addFrom, 'identityExpiringDate', this.addFrom.identityExpiringDate)
            } else {
              this.$set(this.addFrom, 'sfzcq', 2)
            }
            if (this.addFrom.validPeriodTo == '长期') {
              this.$set(this.addFrom, 'jzcq', 1)
              this.$set(this.addFrom, 'validPeriodTo', this.addFrom.validPeriodTo)
            } else {
              this.$set(this.addFrom, 'jzcq', 2)
            }
            if (this.addFrom.driverClassify == 1) {
              if (res.driverTenantCode == '') {
                this.$set(this.addFrom, 'driverTenant', res.driverTenantName)
              } else {
                this.ssdw = [{ tenantCode: res.driverTenantCode, tenantName: res.driverTenantName }]
                this.$set(this.addFrom, 'driverTenant', { tenantCode: res.driverTenantCode, tenantName: res.driverTenantName })
                // console.log('11111111111111111111111111')
                // console.log(this.addFrom.driverTenant.tenantName)
                // console.log(this.addFrom.driverTenantName)
                // this.$set(this.addFrom, 'driverTenantName', this.addFrom.driverTenant.tenantName)
              }
            }
            if (res.identityPhoto1Url) {
              this.$set(this.img, 0, { status: 'ready', url: res.identityPhoto1Url })
              this.$set(this.imgList, 0, 1)
            }
            if (res.identityPhoto2Url) {
              this.$set(this.img1, 0, { status: 'ready', url: res.identityPhoto2Url })
              this.$set(this.imgList, 1, 1)
            }
            if (res.appendix1Url) {
              this.$set(this.img2, 0, { status: 'ready', url: res.appendix1Url })
              this.$set(this.imgList, 2, 1)
            }
            if (res.appendix2Url) {
              this.$set(this.img3, 0, { status: 'ready', url: res.appendix2Url })
              this.$set(this.imgList, 3, 1)
            }
            if (res.qualificationPhotoUrl) {
              this.$set(this.img4, 0, { status: 'ready', url: res.qualificationPhotoUrl })
              this.$set(this.imgList, 4, 1)
            }
            this.newImgFlag = true
          } else {
            let identityNo = this.addFrom.identityNo
            this.addFrom = {
              identityNo: identityNo
            }
            this.imgList = []
            this.img = []
            this.img1 = []
            this.img2 = []
            this.img3 = []
            this.img4 = []
            this.newImgFlag = true
          }
          this.$set(this.addFrom, 'licenseNum', this.addFrom.identityNo)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 修改
    modifyDeiver (row) {
      console.log(row)
      console.log('xiugai')
      console.log(this.isAdd)
      console.log('biaoshi111')
      this.title = '修改司机信息'
      this.addFrom = {}
      if (this.$refs.table) {
        this.$refs.table.clearSelection()
      }
      this.img = []
      this.img1 = []
      this.img2 = []
      this.img3 = []
      this.img4 = []
      this.newImgFlag = false
      // this.flag = false
      this.flag = true
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
      this.isAdd = false
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })

      detailDriver({ driverId: row.id }).then(res => {
        if (row.tenantId != res.tenantId) {
          this.read = true
        } else {
          this.read = false
        }
        loading.close()
        this.addFrom = JSON.parse(JSON.stringify(row))
        this.$set(this.addFrom, 'xname', this.addFrom.provinceName)
        if (this.addFrom.driverClassify == 1) {
          if (row.driverTenantCode == '') {
            this.$set(this.addFrom, 'driverTenant', row.driverTenantName)
          } else {
            this.ssdw = [{ tenantCode: row.driverTenantCode, tenantName: row.driverTenantName }]
            this.$set(this.addFrom, 'driverTenant', { tenantCode: row.driverTenantCode, tenantName: row.driverTenantName })
          }
        }
        if (row.identityPhoto1Url) {
          this.$set(this.img, 0, { status: 'ready', url: row.identityPhoto1Url })
          this.$set(this.imgList, 0, 1)
        }
        if (row.identityPhoto2Url) {
          this.$set(this.img1, 0, { status: 'ready', url: row.identityPhoto2Url })
          this.$set(this.imgList, 1, 1)
        }
        if (row.appendix1Url) {
          this.$set(this.img2, 0, { status: 'ready', url: row.appendix1Url })
          this.$set(this.imgList, 2, 1)
        }
        if (row.appendix2Url) {
          this.$set(this.img3, 0, { status: 'ready', url: row.appendix2Url })
          this.$set(this.imgList, 3, 1)
        }
        if (row.qualificationPhotoUrl) {
          this.$set(this.img4, 0, { status: 'ready', url: row.qualificationPhotoUrl })
          this.$set(this.imgList, 4, 1)
        }

        // if (this.addFrom.identityExpiringDate == '长期') {
        //   this.$set(this.addFrom, 'sfzcq', 1)
        //   this.$set(this.addFrom, 'identityExpiringDate', null)
        // } else {
        //   this.$set(this.addFrom, 'sfzcq', 2)
        // }
        // if (this.addFrom.validPeriodTo == '长期') {
        //   this.$set(this.addFrom, 'jzcq', 1)
        //   this.$set(this.addFrom, 'validPeriodTo', null)
        // } else {
        //   this.$set(this.addFrom, 'jzcq', 2)
        // }
        if (this.addFrom.identityExpiringDate == '长期') {
          this.$set(this.addFrom, 'sfzcq', 1)
          this.$set(this.addFrom, 'identityExpiringDate', row.identityExpiringDate)
        } else {
          this.$set(this.addFrom, 'sfzcq', 2)
        }
        if (this.addFrom.validPeriodTo == '长期') {
          this.$set(this.addFrom, 'jzcq', 1)
          this.$set(this.addFrom, 'validPeriodTo', row.validPeriodTo)
        } else {
          this.$set(this.addFrom, 'jzcq', 2)
        }
        this.newImgFlag = true
        this.dialogVisible = true
        this.isAdd = false
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 添加接口
    addJK (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      cDadd(data).then(res => {
        loading.close()
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.addFrom.id = res.id
        this.dialogVisible = false
        // this.getList(this.searchFrom)
        this.$parent.searchFn()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 修改接口
    xiugaiJK (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      cDupdate(data).then(res => {
        loading.close()
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.dialogVisible = false
        // this.getList(this.searchFrom)
        this.$parent.searchFn()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/ .hide .el-upload--picture-card {
  display: none;
}
}
.addressBox{
  display: flex!important;
  justify-content: space-between;
  margin-bottom: 10px;
  .title{
    margin: 0!important;
  }
}
.FKbox{
  /deep/ .el-form-item--mini.el-form-item{
    margin: 4px;
    margin-bottom: 16px;
  }
}
.box{
  display: flex;
  flex-wrap: wrap;
  .imgBox{
    display: flex;
      margin-right:30px;
    flex-direction: column;
    width: 320px;
    /deep/.el-upload--picture-card{
          width: 320px;
    height: 200px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../assets/images/upload1.png);
    background-size: 320px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 320px;
    height: 200px;
  }
}
.detailBox .el-form-item span{
  display:inline-block;
  width: 150px;
}
.detailBox img{
   width: 320px;
    height: 200px;
}
.detailBox /deep/ .el-date-editor--date .el-input__inner{
  border: none;
  font-size: 14px;
}
.jiaoyan .inpBox /deep/.el-date-editor .el-input__inner{
  width: 150px;
}
/deep/.el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: black;
    cursor: not-allowed;
}
.disabled /deep/.el-input__inner {
  background: #dcedff;
    color: black;
}
/deep/.el-radio__input.is-disabled+span.el-radio__label {
    color: black;
    cursor: not-allowed;
}
</style>
